import { ProgramType } from "src/enums";
import { Config } from "./config";


export const Urls = {
    config: {
        get: () => ({ method: 'GET', base: Config.apiUrl, url: 'configuration/init', noCacheHeader: false })
    },

    content: {
        packageGuide: () => ({ method: 'GET', base: Config.apiUrl, url: 'page/package_guide', noCacheHeader: false }),

        aboutUs: () => ({ method: 'GET', base: Config.apiUrl, url: 'page/about_us', noCacheHeader: false }),

        apps: () => ({ method: 'GET', base: Config.apiUrl, url: 'configuration/download', noCacheHeader: false })
    },

    auth: {
        login: () => ({ method: 'POST', base: Config.apiUrl, url: 'users', noCacheHeader: false }),

        verify: (id: number) => ({ method: 'POST', base: Config.apiUrl, url: `users/${id}/sessions`, noCacheHeader: false }),

        loginFromParam: () => ({ method: 'POST', base: Config.apiUrl, url: 'z/u', noCacheHeader: false }),

        loginInIranLeague: () => ({ method: 'POST', base: Config.apiUrl, url: 'users/decodeiranleague', noCacheHeader: false })
    },

    profile: {
        info: () => ({ method: 'GET', base: Config.apiUrl, url: 'users/self', noCacheHeader: true }),

        update: () => ({ method: 'POST', base: Config.apiUrl, url: 'users/update', noCacheHeader: false }),

        giftCode: (code: string) => ({ method: 'GET', base: Config.apiUrl, url: `payment/giftcode/${code}`, noCacheHeader: false }),

        packageSummaries: () => ({ method: 'GET', base: Config.apiUrl, url: 'package/mycurrent', noCacheHeader: true }),

        packageHistory: (count: number, offset: number) => ({
            method: 'GET', base: Config.apiUrl,
            url: `package/myhistory?count=${count}&offset=${offset}`,
            noCacheHeader: true
        }),

        devices: {
            list: (page: number) => ({ method: 'GET', base: Config.apiUrl, url: `devices/list?page=${page}`, noCacheHeader: false }),

            connectCurrentSendCode: () => ({ method: 'POST', base: Config.apiUrl, url: 'devices/connectCurrectSendCode', noCacheHeader: false }),

            connectCurrectConfirmCode: () => ({ method: 'POST', base: Config.apiUrl, url: 'devices/connectCurrectConfirmCode', noCacheHeader: false }),

            cutAllSendCode: () => ({ method: 'POST', base: Config.apiUrl, url: 'devices/cutAllSendCode', noCacheHeader: false }),

            cutAllConfirmCode: () => ({ method: 'POST', base: Config.apiUrl, url: 'devices/cutAllConfirmCode', noCacheHeader: false }),
        },

        favorites: () => ({ method: 'GET', base: Config.apiUrl, url: 'user-favorites', noCacheHeader: false })
    },

    program: {
        addTraffic: (id: number) => ({ method: 'POST', base: Config.apiUrl, url: `programs/${id}/traffic`, noCacheHeader: false }),

        getById: (id: number) => ({ method: 'GET', base: Config.apiUrl, url: `programs/${id}`, noCacheHeader: true }),

        issue: (id: number) => ({ method: 'POST', base: Config.apiUrl, url: `programs/${id}/issues`, noCacheHeader: false }),

        ipCheck: () => ({ method: 'POST', base: Config.apiUrl, url: `ipReports`, noCacheHeader: false }),

        list: (count: number, type: ProgramType, offset: number, getFeatured: boolean) => ({
            method: 'GET', base: Config.apiUrl, noCacheHeader: true,
            url: `programs?count=${count}&getFeatured=${getFeatured}&type=${ProgramType[type]}&offset=${offset}&clientPlatform=4`
        }),
        slider : () => ({ method: 'GET', base: Config.apiUrl, url: `sliders`, noCacheHeader: false })
    },

    reports: {

        tvPlayBack: (channelId: number, conductorId?: number) => ({
            method: 'POST', base: Config.reportPlaybackUrl, noCacheHeader: false,
            url: `channels/${channelId}/${conductorId ? `conductor/${conductorId}/` : ""}reportPlayback`
        }),

        tvStatistic: (channelId: number, conductorId?: number) => ({
            method: 'POST', base: Config.statisticUrl, noCacheHeader: false,
            url: `stats/${conductorId ? "conductor" : "tvchannel"}/${channelId}/${conductorId || ""}`
        })

    },

    archive: {
        getById: (id: number) => ({ method: 'GET', base: Config.apiUrl, url: `programs/${id}`, noCacheHeader: true }),

        list: (count: number, type: number, offset: number, searchText: string) => ({
            method: 'GET', base: Config.apiUrl, noCacheHeader: true,
            url:
                `programs?count=${count}&getFeatured=true&type=${type}&offset=${offset}&clientPlatform=4&query=${searchText}`
        }),

    },

    promotions: {
        getByProgramId: (id: number) => ({ method: 'GET', base: Config.apiUrl, url: `promotions/programdetail/${id}`, noCacheHeader: false }),
    },

    order: {

        packages: () => ({ method: 'GET', base: Config.apiUrl, url: `package/list`, noCacheHeader: true }),

        packageDetail: (packageId: number) => ({ method: 'GET', base: Config.apiUrl, url: `package/profiles/${packageId}`, noCacheHeader: true }),

        info: (orderId: number) => ({ method: 'GET', base: Config.apiUrl, url: `order/info/${orderId}`, noCacheHeader: true }),

        addDiscount: () => ({ method: 'POST', base: Config.apiUrl, url: 'order/discount', noCacheHeader: false }),

        removeDiscount: () => ({ method: 'POST', base: Config.apiUrl, url: 'order/removeDiscount', noCacheHeader: false }),

        create: () => ({ method: 'POST', base: Config.apiUrl, url: 'order/create', noCacheHeader: false })
    },


    tv: {

        channels: () => ({ method: 'GET', base: Config.apiUrl, url: 'channels', noCacheHeader: true }),

        channel: (id: number, killSessionId?: string) => ({
            method: 'GET', base: Config.apiUrl, noCacheHeader: true,
            url: `channels/${id}/url${killSessionId ? `?killSessionId=${killSessionId}` : ""}`
        }),

        conductor: (id: number, date?: Date | string) => ({
            method: 'GET', base: Config.apiUrl, true: false, noCacheHeader: true,
            url: `conductor/channels/${id}/conductor?${date ? `date=${date}` : ""}`
        }),

        episod: (channelId: number, killSessionId: string | undefined, conductorId: number) => ({
            method: 'GET', base: Config.apiUrl, true: false, noCacheHeader: true,
            url: `conductor/channels/${channelId}/conductor/${conductorId}/episode${killSessionId ? `?killSessionId=${killSessionId}` : ""}`
        }),

    },

    feedback: {
        post: () => ({ method: 'POST', base: Config.apiUrl, url: 'feedbacks', noCacheHeader: false }),
        types: () => ({ method: 'GET', base: Config.apiUrl, url: 'feedbacks', noCacheHeader: false }),
    },

    packApi: (base: string | null | undefined, url: string, method: string, noCacheHeader: boolean) => ({ base, url, method, noCacheHeader })

};